import React, { useState } from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import QueryBuilderOutlinedIcon from '@mui/icons-material/QueryBuilderOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import OutboundOutlinedIcon from '@mui/icons-material/OutboundOutlined';
import TimelapseOutlinedIcon from '@mui/icons-material/TimelapseOutlined';
import MoreTimeOutlinedIcon from '@mui/icons-material/MoreTimeOutlined';
import SmsFailedOutlinedIcon from '@mui/icons-material/SmsFailedOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { ReactComponent as LogIQmindIcon } from 'assets/img/LogIQmindIcon.svg';
import { SvgIcon } from '@mui/material';
import { PortalNames } from "common/Portals";
import { Utils } from 'common/Utils';

export var SidebarData = {
    getItems: (userInfo) => {
        var sidebarItems = [];
        var groupType = userInfo?.companyDetails?.groupType ?? "";

        sidebarItems.push({
            title: "Dashboard",
            icon: <DashboardOutlinedIcon />,
            link: `/${PortalNames.CollectionVendor.Path}/dashboard`,
            index: 1,
        });

        sidebarItems.push({
            title: "Important Align Admin Messages",
            icon: <MessageOutlinedIcon />,
            link: `/${PortalNames.CollectionVendor.Path}/messages`,
            index: 2,
        });

        sidebarItems.push({
            title: "Files",
            icon: <DescriptionOutlinedIcon />,
            link: `/${PortalNames.CollectionVendor.Path}/files`,
            index: 5,
        });
        sidebarItems.push({
            title: "Uploads",
            icon: <PublishOutlinedIcon />,
            link: `/${PortalNames.CollectionVendor.Path}/uploads`,
            index: 8,
        });

        sidebarItems = sidebarItems.sort((a, b) => a.index - b.index);

        return sidebarItems;
    }
}
